import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
	floatingButton: {
    transition: "transform 0.3s",
    "&:hover": { transform: "translateY(-5px)", },
  }
}));

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useStyles();

	return (
		<Dialog open={open} onClose={() => onClose(false)} aria-labelledby="confirm-dialog" >
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>

			<DialogContent dividers>
				<Typography>{children}</Typography>
			</DialogContent>
			
			<DialogActions>
				<Button
					variant="contained"
					onClick={() => onClose(false)}
					color="default"
					className={classes.floatingButton}
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
					color="secondary"
					className={classes.floatingButton}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
